/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ConduitFamilyInformation } from '../../components/add-family-information/conduit-family-information/conduit-family-information.component';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class ConduitFamilyInformationDialog implements PopupDialog {
    create(sysquePopupConfig: SysquePopupConfig): any {
      sysquePopupConfig.component = ConduitFamilyInformation;
      sysquePopupConfig.width = 1080;
      sysquePopupConfig.height = 815;
      sysquePopupConfig.componentTitle = '';
      sysquePopupConfig.visible = true;
    }
  }